"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSource = void 0;
class DataSource {
    constructor(params = {}) {
        Object.assign(this, params);
    }
    isClientSide() {
        return (this.slug || '').includes(DataSource.BIDDR_SLUG);
    }
    isServerSide() {
        return (this.slug || '').includes(DataSource.RTB_SLUG);
    }
    isConnect() {
        return (this.slug || '').includes(DataSource.CONNECT_SLUG);
    }
    isDeals() {
        return (this.slug || '').includes(DataSource.DEALS_SLUG);
    }
    isServerSideOrDealsOrConnect() {
        return (this.isServerSide() || this.isDeals());
    }
    getDisplayName({ showAsProduct }) {
        if (showAsProduct && this.product) {
            return this.product.displayName;
        }
        return this.displayName;
    }
}
exports.DataSource = DataSource;
DataSource.BIDDR_SLUG = 'biddr';
DataSource.RTB_SLUG = 'rtbx';
DataSource.DEALS_SLUG = 'deals';
DataSource.CONNECT_SLUG = 'connect';
//# sourceMappingURL=data-source.js.map